<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      width="520px"
      :title="title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
      append-to-body
      v-el-dialog-drag
    >
      <edit-form
        ref="editForm"
        :multipleDisabled="multipleDisabled"
        :templateCode="templateCode"
        @close="$emit('close')"
        @reload="$emit('reload')"
        @updateTableData="updateTableData"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="$refs.editForm.save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EditForm from './index.vue'
export default {
  components: {
    EditForm,
  },
  props: {
    multipleDisabled: { type: Boolean, default: false },
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    templateCode: { type: String, default: '' },
  },
  methods: {
    updateTableData(data) {
      this.$emit('updateTableData', data)
    },
  },
}
</script>
